<template>
  <div v-if="visible" class="ui negative message">
    <i class="close icon" @click="hide"></i>
    <div class="header">{{ header }}</div>
    <p>{{ this.message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    header: String,
    message: String,
    visible: Boolean,
    'updateVisibility': Function
  },
  methods: {
    hide () {
      this.updateVisibility(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Alert.vue